import {ConfigurationMissingError, OptionsMissingError} from './errors';
import A11yConsentApi from './a11y-consent-api';

let A11yConsent: A11yConsentApi | null = null;

try {
  A11yConsent = new A11yConsentApi();
  document.addEventListener('DOMContentLoaded', () => {
    // Make sure, that the JavaScript API is present, as it might have been removed by an AdBlocker
    if (typeof A11yConsent !== 'undefined' && A11yConsent) {
      A11yConsent.initialize();
    }
  });
} catch (e) {
  if (e instanceof ConfigurationMissingError || e instanceof OptionsMissingError) {
    // Fail silently; maybe an AdBlocker has removed the consent configuration, or there is simply no consent
    // configuration present
  } else {
    throw e;
  }
}

export default A11yConsent;
